import { useState } from 'react';
import { X, Clock, Calendar } from 'lucide-react';
import { TIME_SLOTS } from '../constants';

export const WaitlistModal = ({ isOpen, onClose, waitlist = [], onSchedule }) => {
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [schedulingData, setSchedulingData] = useState({
    date: '',
    timeSlot: ''
  });

  const handleSchedule = async () => {
    try {
      await onSchedule(selectedEntry._id, schedulingData);
      setSelectedEntry(null);
      setSchedulingData({ date: '', timeSlot: '' });
    } catch (error) {
      console.error('Failed to schedule from waitlist:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">Waitlist Management</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4">
          {selectedEntry ? (
            <div>
              <h4 className="text-lg font-medium mb-4">
                Schedule Appointment for {selectedEntry.client?.fullName}
              </h4>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Select Date
                  </label>
                  <div className="mt-1 relative">
                    <Calendar className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                    <input
                      type="date"
                      min={new Date().toISOString().split('T')[0]}
                      className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      value={schedulingData.date}
                      onChange={(e) => setSchedulingData(prev => ({
                        ...prev,
                        date: e.target.value
                      }))}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Select Time Slot
                  </label>
                  <div className="mt-1 relative">
                    <Clock className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                    <select
                      className="pl-10 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      value={schedulingData.timeSlot}
                      onChange={(e) => setSchedulingData(prev => ({
                        ...prev,
                        timeSlot: e.target.value
                      }))}
                    >
                      <option value="">Select time slot</option>
                      {TIME_SLOTS.map(slot => (
                        <option key={slot} value={slot}>{slot}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setSelectedEntry(null)}
                    className="px-4 py-2 text-gray-700 border rounded-md hover:bg-gray-50"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleSchedule}
                    disabled={!schedulingData.date || !schedulingData.timeSlot}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                  >
                    Schedule Appointment
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              {waitlist.length === 0 ? (
                <p className="text-center text-gray-500 py-4">No clients in waitlist</p>
              ) : (
                waitlist.map((entry) => (
                  <div key={entry._id} className="border rounded-lg p-4">
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-medium">{entry.client?.fullName}</h4>
                        <p className="text-sm text-gray-500">
                          Added on {new Date(entry.waitlistedAt).toLocaleDateString()}
                        </p>
                      </div>
                      <button
                        onClick={() => setSelectedEntry(entry)}
                        className="px-3 py-1 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100"
                      >
                        Schedule
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};